import React, { useEffect, useState } from "react";
import {
  IconArchive,
  IconPresentation,
  IconSparkles,
  IconLayoutDashboard,
  IconTimelineEvent,
  IconFile,
  IconZoomCheck,
  IconFlag,
  IconWorld,
} from "@tabler/icons-react";
import { concat } from "lodash";
import TimelineFelix from "../timeline";
import Conta from "../conta";
import Importacao from "../arquivo";
import Nota from "../arquivo/nota";
import DetalhesMes from "../fechamento";
import Darf from "../darf";
import Relatorios from "../declaracao/relatorios";
import Declaracao from "../declaracao/index";
import Painel from "../painel";
import CadastrarPontoDePartida from "../arquivo/cadastrarPontoDePartida";
import Subscricao from "../arquivo/subscricao";
import Upload from "../arquivo/upload";
import Analises from "../analises";
import Statement from "../arquivo/statement";
import MercadoInternacional from "../internacional";
import ArquivoInternacional from "../internacional/arquivo";
import { styled } from "@mui/material/styles";
import {
  Avatar,
  Badge,
  Box,
  List,
  ListItem,
  ListItemIcon,
  Tooltip,
} from "@mui/material";
import { useMatch } from "react-router-dom";
import { isMatch, map } from "lodash";
import { IconBriefcase } from "@tabler/icons-react";
import { Claims, useUsuario } from "../../../providers/usuarioProvider";
import Business from "../../../models/business";
import { onSnapshot } from "firebase/firestore";
import BusinessDb from "../../../db/businessDb";
import PermissaoDisplay from "../../util/permissaoDisplay";
import Permissoes from "../../../models/permissoes";
import { Perfil } from "../../../models/enum";
import AssinaturaConfirmada from "../assinatura/assinaturaConfirmada";
import RevisarPermissoes from "../conta/business/revisarPermissoes";
import Inteligencia from "../inteligencia";
import withMainLayout from "../../util/routes/withMainLayout";
import Consulta from "../consulta";
import Checkpoints from "../checkpoint";
import FelixAvatar from "../../util/ui/felixAvatar";
import SaldoCreditos from "./saldoCreditos";
import Creditos from "../creditos";
import { Link } from "react-router-dom";
import Usuario from "../../../models/usuario";
import { radius } from "../../../theme";
const PREFIX = "menuRotas";

const classes = {
  lista: `${PREFIX}-lista`,
  drawerItem: `${PREFIX}-drawerItem`,
  drawerItemIcon: `${PREFIX}-drawerItemIcon`,
  avatar: `${PREFIX}-avatar`,
  badge: `${PREFIX}-badge`,
  individual: `${PREFIX}-individual`,
};

const StyledList = styled(List)(({ theme }) => ({
  [`&.${classes.lista}`]: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },

  // O rail segue o tema (ver `withMainLayout`), então o ícone segue junto:
  // `text.secondary` em repouso, `text.primary` sobre o chip de ativo.
  [`& .${classes.drawerItem}`]: {
    padding: theme.spacing(1, 0),
    justifyContent: "center",
    "&.MuiButtonBase-root.Mui-selected, &:hover": {
      backgroundColor: "transparent",
    },
    "&:hover > .MuiListItemIcon-root, &:focus > .MuiListItemIcon-root": {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.text.primary,
    },
    "&.Mui-selected > .MuiListItemIcon-root": {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.text.primary,
    },
  },

  [`& .${classes.drawerItemIcon}`]: {
    color: theme.palette.text.secondary,
    justifyContent: "center",
    minWidth: 32,
    padding: theme.spacing(1),
    borderRadius: radius.md,
    transition: theme.transitions.create(["background-color", "color"], {
      duration: 120,
      easing: "ease-out",
    }),
  },

  [`& .${classes.avatar}`]: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    fontSize: "1rem",
  },

  [`& .${classes.badge}`]: { padding: theme.spacing(0) },

  [`& .${classes.individual}`]: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
  },
}));

export default function MenuRotas() {
  const { usuario, profilePicture } = useUsuario();
  const [business, setBusiness] = useState<Business>();
  const { claims } = useUsuario();

  useEffect(() => {
    if (!!usuario?.business)
      return onSnapshot(
        new BusinessDb().doc({ businessId: usuario.business }),
        (snapshot) => setBusiness(snapshot.data()),
      );
  }, [usuario?.business]);

  return (
    <StyledList className={classes.lista}>
      {map(RotasMenu, (rota) => {
        const rotaResolvida =
          rota.pathname === "/internacional"
            ? {
                ...rota,
                novidade: !usuario?.preferencias?.mercadoInternacional,
              }
            : rota;
        return <MenuItem rota={rotaResolvida} key={rota.pathname} />;
      })}
      <Box display="flex" flexGrow={1} />
      <Tooltip
        title="Créditos para usar em Análises Inteligentes"
        placement="left"
        key="creditos"
      >
        <ListItem
          button
          className={classes.drawerItem}
          component={Link}
          to="/creditos"
        >
          <SaldoCreditos />
        </ListItem>
      </Tooltip>
      <MenuItemConta
        claims={claims}
        business={business}
        usuario={usuario}
        profilePicture={profilePicture}
      />
    </StyledList>
  );
}

type Rota = {
  pathname: string;
  titulo: string;
  componente: React.FC<any>;
  permissao: Partial<Permissoes>;
};

type RotaMenu = Rota & {
  icone: JSX.Element;
  class: string;
  novidade?: boolean;
};

export const RotasMenu: RotaMenu[] = [
  {
    pathname: "/painel",
    titulo: "Painel",
    componente: withMainLayout(Painel),
    icone: <IconLayoutDashboard />,
    class: "painel",
    permissao: {},
  },
  {
    pathname: "/timeline",
    titulo: "Timeline",
    componente: withMainLayout(TimelineFelix),
    icone: <IconTimelineEvent />,
    class: "timeline",
    permissao: { ver_timeline: true },
  },
  {
    pathname: "/declaracao",
    titulo: "Declaração",
    componente: withMainLayout(Declaracao),
    icone: <IconFile />,
    class: "declaracao",
    permissao: { ver_relatorios: true },
  },
  {
    pathname: "/analises",
    titulo: "Análises",
    componente: withMainLayout(Analises),
    icone: <IconPresentation />,
    class: "analises",
    permissao: { ver_analises: true },
  },
  {
    pathname: "/inteligencia-contabil",
    titulo: "Inteligência Contábil",
    componente: withMainLayout(Inteligencia),
    icone: <IconSparkles />,
    class: "inteligencia-contabil",
    permissao: { ver_inteligencia: true },
  },
  {
    pathname: "/checkpoint",
    titulo: "Ponto de Verificação",
    componente: withMainLayout(Checkpoints),
    icone: <IconFlag />,
    class: "checkpoint",
    permissao: { buscar: true },
  },
  {
    pathname: "/consulta",
    titulo: "Consulta de Ativos",
    componente: withMainLayout(Consulta),
    icone: <IconZoomCheck />,
    class: "consulta",
    permissao: { buscar: true },
  },
  {
    pathname: "/arquivo",
    titulo: "Arquivo",
    componente: withMainLayout(Importacao),
    icone: <IconArchive />,
    class: "arquivo",
    permissao: { incluir_nota: true },
  },
  {
    pathname: "/internacional",
    titulo: "Mercado Internacional",
    componente: withMainLayout(MercadoInternacional),
    icone: <IconWorld />,
    class: "internacional",
    permissao: { incluir_nota: true },
  },
];

export const Rotas: Rota[] = concat<Rota>(RotasMenu, [
  {
    pathname: "/conta",
    titulo: "Conta",
    componente: withMainLayout(Conta),
    permissao: {},
  },
  {
    pathname: "/arquivo/nota/:notaId",
    titulo: "Nota",
    componente: withMainLayout(Nota),
    permissao: { incluir_nota: true },
  },
  {
    pathname: "/internacional/statement/:uploadId",
    titulo: "Statement",
    componente: withMainLayout(Statement),
    permissao: { incluir_nota: true },
  },
  {
    pathname: "/internacional/arquivo",
    titulo: "Gerenciar Statements",
    componente: withMainLayout(ArquivoInternacional),
    permissao: { incluir_nota: true },
  },
  {
    pathname: "/timeline/mes/:impostoId",
    titulo: "Detalhes do mês",
    componente: withMainLayout(DetalhesMes),
    permissao: { ver_imposto: true },
  },
  {
    pathname: "/timeline/darf",
    titulo: "DARF",
    componente: withMainLayout(Darf),
    permissao: { gerar_darf: true },
  },
  {
    pathname: "/declaracao/:declaracaoId",
    titulo: "Declaração",
    componente: withMainLayout(Relatorios),
    permissao: { ver_relatorios: true },
  },
  {
    pathname: "/timeline/ponto-de-partida",
    titulo: "Ponto de partida",
    componente: withMainLayout(CadastrarPontoDePartida),
    permissao: { incluir_nota: true },
  },
  {
    pathname: "/arquivo/upload/:uploadId",
    titulo: "Upload",
    componente: withMainLayout(Upload),
    permissao: { incluir_nota: true },
  },
  {
    pathname: "/arquivo/subscricao",
    titulo: "Subscrição",
    componente: withMainLayout(Subscricao),
    permissao: { incluir_nota: true },
  },
  {
    pathname: "/sucesso",
    titulo: "Assinatura confirmada",
    componente: withMainLayout(AssinaturaConfirmada),
    permissao: {},
  },
  {
    pathname: "/cliente",
    titulo: "Revisar Permissões",
    componente: withMainLayout(RevisarPermissoes),
    permissao: { gerenciar_clientes: true },
  },
  {
    pathname: "/colaborador",
    titulo: "Revisar Permissões",
    componente: withMainLayout(RevisarPermissoes),
    permissao: { gerenciar_usuarios: true },
  },
  {
    pathname: "/creditos",
    titulo: "Créditos",
    componente: withMainLayout(Creditos),
    permissao: {},
  },
]);

type MenuItemContaProps = {
  claims?: Claims;
  business?: Business;
  usuario?: Usuario;
  profilePicture?: string;
};

function MenuItemConta({
  claims,
  business,
  usuario,
  profilePicture,
}: MenuItemContaProps) {
  const match = useMatch(`/conta/*`);
  return (
    <Tooltip title="Conta" placement="left" key="conta">
      <ListItem
        button
        component={Link}
        to={"/conta"}
        key="conta"
        selected={!!match}
        className={classes.drawerItem}
      >
        <ListItemIcon className={classes.drawerItemIcon}>
          <Badge
            invisible={claims?.perfil !== Perfil.CONTADOR}
            overlap="circular"
            color="secondary"
            sx={{ "& .MuiBadge-badge": { p: 0 } }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            badgeContent={
              <Avatar
                sx={{ width: 20, height: 20, bgcolor: "secondary.main" }}
                src={business?.imagemUrl || ""}
                alt={business?.nome || "Business"}
              >
                <IconBriefcase size={10} />
              </Avatar>
            }
          >
            <FelixAvatar
              nome={usuario?.nome ?? ""}
              size={40}
              perfil={claims?.perfil ?? Perfil.INVESTIDOR}
              fotoDePerfil={usuario?.fotoDePerfil ?? profilePicture}
            />
          </Badge>
        </ListItemIcon>
      </ListItem>
    </Tooltip>
  );
}

function MenuItem({ rota }: { rota: RotaMenu }) {
  const match = useMatch(`${rota.pathname}/*`);
  return (
    <PermissaoDisplay
      match={(claims) => {
        return (
          !!claims?.permissoes && isMatch(claims.permissoes, rota.permissao)
        );
      }}
    >
      <Tooltip title={rota.titulo} placement="left" key={rota.titulo}>
        <ListItem
          button
          component={Link}
          to={`${rota.pathname}`}
          selected={!!match}
          className={`${classes.drawerItem} ${rota.class}`}
        >
          <ListItemIcon className={classes.drawerItemIcon}>
            {/* "novidade" mapeia para o semântico accent (processando/novo),
                mas na TINTA (`info` = accent-ink no tema): um dot de 8px em
                `primary.main` dá 2,57:1 sobre a superfície escura e some. */}
            <Badge color="info" invisible={!!!rota.novidade} variant="dot">
              {rota.icone}
            </Badge>
          </ListItemIcon>
        </ListItem>
      </Tooltip>
    </PermissaoDisplay>
  );
}
